module.exports = __webpack_public_path__ + "img/norma-minkowitz.7b27f12f.png";